export function parseDiscussionPaginationMeta(response: unknown): {
  totalCount: number;
  totalPages: number;
} {
  const res = response as {
    data?: { meta?: DiscussionMeta };
    meta?: DiscussionMeta;
  } | null;
  const meta = res?.data?.meta ?? res?.meta;
  if (!meta) {
    return { totalCount: 0, totalPages: 1 };
  }
  return {
    totalCount: meta.total_count ?? meta.totalCount ?? 0,
    totalPages: meta.total_pages ?? meta.totalPages ?? 1,
  };
}

interface DiscussionMeta {
  total_count?: number;
  totalCount?: number;
  total_pages?: number;
  totalPages?: number;
}
